import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"

import HeaderBanner from "../components/headerBanner"
import Video from "../components/video"
import Faqs from "../components/faqs"
import Speakers from "../components/speakers"
import Partners from "../components/partners"
import Text from "../components/text"
import Roadshow from "../components/roadshow"
import Highlights from "../components/highlights"

//import Articles from "../components/articles";
import Events from "../components/events"

import Layout from "../components/layout"

const NodePage = ({ data }) => {
  const page = data.nodePage
  return (
    <Layout>
      <div className={"page-content content__theme-" + page.field_theme}>
        {page.relationships.field_paragraph_ref.length > 0 &&
          page.relationships.field_paragraph_ref.map((paragraph, index) => {
            switch (paragraph.__typename) {
              case "paragraph__header_banner":
                return <HeaderBanner data={paragraph} key={index} />

              case "paragraph__faqs":
                return <Faqs data={paragraph} key={index} />

              case "paragraph__speakers":
                return <Speakers data={paragraph} key={index} />

              case "paragraph__roadshow":
                return <Roadshow data={paragraph} key={index} />

              case "paragraph__events":
                return <Events content={paragraph} key={index} />

              case "paragraph__partners":
                return <Partners data={paragraph} key={index} />

              case "paragraph__roadmap_tiles":
                return <Highlights data={paragraph} key={index} />

              case "paragraph__text":
                return <Text data={paragraph} key={index} />

              case "paragraph__video_section":
                return <Video data={paragraph} key={index} />

              case "paragraph__img_txt":
                return <Text data={paragraph} key={index} />

              default:
                return <></>
            }
          })}
      </div>
    </Layout>
  )
}

export default NodePage

NodePage.propTypes = {
  data: PropTypes.object.isRequired,
}

export const query = graphql`
  query($id: String) {
    nodePage(id: { eq: $id }) {
      title
      field_theme
      relationships {
        field_paragraph_ref {
          
          ... on paragraph__header_banner {
            field_heading
            relationships {
              field_image {
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        original {
                          src
                        }
                      }
                    }
                  }
                }
              }
              field_banner {
                relationships {
                  field_media_image {
                    localFile {
                      childImageSharp {
                        original {
                          src
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          ... on paragraph__roadmap_tiles {
            field_heading
            field_desc {
              processed
            }
            relationships {
              field_tiles_ref {
                field_heading
                field_desc {
                  processed
                }
                relationships {
                  field_image {
                    relationships {
                      field_media_image {
                        localFile {
                          childImageSharp {
                            original {
                              src
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          ... on paragraph__video_section {
            anchor: field_short_txt
            field_subhead
            field_heading
            field_desc {
              processed
            }
            field_youtube_embed {
              uri
            }
            field_cta {
              title
              uri
            }
          }
          ... on paragraph__text {
            anchor: field_short_txt
            subhead: field_subhead
            heading: field_heading
            layout: field_imgtxt_layout
            desc: field_desc {
              processed
            }
            cta: field_cta {
              title
              uri
            }
            relationships {
              field_image {
                relationships {
                  image: field_media_image {
                    localFile {
                      childImageSharp {
                        original {
                          src
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          ... on paragraph__events {
            anchor: field_short_txt
            field_heading
            field_subhead
            field_desc {
              processed
            }
            field_cta {
              title
              uri
            }
          }
          ... on paragraph__partners {
            anchor: field_short_txt
            field_heading
            field_subhead
            field_desc {
              processed
            }
            relationships {
              field_images {
                ... on media__image {
                  relationships {
                    field_media_image {
                      localFile {
                        childImageSharp {
                          fixed {
                            src
                          }
                        }
                      }
                    }
                  }
                }
                ... on media__logo {
                  field_url {
                    uri
                  }
                  relationships {
                    field_media_image {
                      localFile {
                        childImageSharp {
                          fixed {
                            src
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          ... on paragraph__events {
            anchor: field_short_txt
            field_cta {
              title
              uri
            }
          }

          ... on paragraph__speakers {
            anchor: field_short_txt
            field_heading
            field_subhead
            field_desc {
              processed
            }
            field_speaker_type
            relationships {
              field_tiles_ref {
                field_heading
                field_subhead
                field_desc {
                  processed
                }
                field_twitter {
                  uri
                }
                field_linkedin {
                  uri
                }
                field_insta {
                  uri
                }
                relationships {
                  field_image {
                    relationships {
                      field_media_image {
                        localFile {
                          publicURL
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          ... on paragraph__faqs {
            anchor: field_short_txt
            field_heading
            field_subhead
            field_desc {
              processed
            }
            relationships {
              field_tiles_ref {
                field_answer
                field_question
              }
            }
          }
          ... on paragraph__roadshow {
            anchor: field_short_txt
            field_heading
            field_subhead
            relationships {
              field_tiles_ref {
                field_heading
                field_subhead
                field_desc {
                  processed
                }
                relationships {
                  field_image {
                    relationships {
                      field_media_image {
                        localFile {
                          childImageSharp {
                            fixed {
                              src
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            field_desc {
              processed
            }
            field_cta {
              title
              uri
            }
          }
        }
      }
    }
  }
`
